import {ContactGroup} from 'iterfaces/contact-group';

import * as ACTIONS from './types';

export const setContactGroups = (contactGroups: ContactGroup[]) => ({
    payload: {contactGroups},
    type: ACTIONS.SET_CONTACT_GROUPS,
});
